const messages = {
    ru: {
        form: {
            email_address: 'Адрес электронной почты',
            password: 'пароль',
        },
        search_bar: {
            search_jobs: 'Поиск вакансий',
            search_keyword: 'Поиск по ключевому слову',
            select_classification: 'Выберите классификацию',
            select_location: 'Выберите место',
        },
        button: {
            save_job_alert: 'сохранить оповещение о вакансии',
        },
    },
};

export default messages;